import AdsInfo from '@containers/AdsInfo';
import Layout from '@containers/Layout';
import Main from '@containers/Main';
import Namespace from '@containers/Namespace';
import { useAppDispatch } from '@hooks/useStore';
import { globalActions } from '@redux/slices/global';
import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

// eslint-disable-next-line
const NoMatch = () => {
    const dispatch = useAppDispatch();
    const setError = (errorCode: number) => dispatch(globalActions.setError({ code: errorCode }));

    useEffect(() => {
        setError(404);
    }, []);

    return null;
};

export default function AppRouter() {
    return (
        <Routes>
            <Route path="/" element={<Main />} />
            <Route path="/help" element={<Main />} />
            <Route path="/info" element={<AdsInfo />} />
            <Route element={<Layout />}>
                <Route path="/:namespace" element={<Namespace />} />
                <Route path="/:namespace/:document" element={<Namespace />} />

                <Route path="*" element={<NoMatch />} />
            </Route>
        </Routes>
    );
}
